/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBuildIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-build"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9 15.25Q6.33 15.25 4.46 13.36Q2.6 11.47 2.6 8.8Q2.6 8.35 2.69 7.7Q2.77 7.05 2.98 6.65Q3.13 6.35 3.39 6.16Q3.65 5.97 3.95 5.92Q4.25 5.88 4.55 5.96Q4.85 6.05 5.1 6.3L7.6 8.8L9 7.4L6.47 4.9Q6.22 4.65 6.14 4.35Q6.05 4.05 6.1 3.75Q6.15 3.45 6.34 3.19Q6.53 2.92 6.83 2.77Q7.25 2.58 7.9 2.49Q8.55 2.4 9 2.4Q11.68 2.4 13.56 4.26Q15.45 6.13 15.45 8.8Q15.45 9.3 15.38 9.8Q15.3 10.3 15.15 10.8L19.82 15.43Q20.7 16.3 20.7 17.5Q20.7 18.7 19.85 19.57Q18.98 20.45 17.73 20.46Q16.48 20.48 15.6 19.6L11 14.95Q10.55 15.1 10.04 15.18Q9.53 15.25 9 15.25Z" fill={color} />
    </svg>
  );
}
